import { DELIVERY_TYPE, DINEIN_TYPE, PICKUP_TYPE } from '../../../../webStorage/keys/sessionKeys';

export const returnObjectKey = (orderType) => {
  return (
    (orderType == DINEIN_TYPE && 'DINING') ||
    (orderType == DELIVERY_TYPE && 'DELIVERY') ||
    (orderType == PICKUP_TYPE && 'TAKEAWAY')
  );
};
